import React from 'react';
import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import useForecastDate from 'hooks/Meteorology/Agro/CultureIndex/Area/useForecastDate';

export default function ForecastDate({ map }: {
  map: CultureIndexAreaMap,
}) {
  const {
    forecastDate,
    setForecastDate,
    availableDates,
  } = useForecastDate(map);

  return (
    <Accordion.Item eventKey="forecast-date" id={`culture-index-forecast-date-${map.id}`}>
      <Accordion.Header>Data de previsão</Accordion.Header>
      <Accordion.Body>
        <DatePicker
          inline
          selected={forecastDate}
          onChange={setForecastDate}
          includeDates={availableDates}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
